import { __decorate } from "tslib";
import Component from 'vue-class-component';
import StringUtils from '@/utils/stringUtils';
import authService from '@/services/authService';
import ReactiveComponent from '../components/ReactiveComponent';
import Task from '@/services/task';
import ProgressButton from "@/components/ProgressButton.vue";
let ResetPassword = class ResetPassword extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.email = '';
        this.invalidEmail = false;
        this.submitTask = Task.idle();
    }
    submit() {
        this.invalidEmail = StringUtils.isBlank(this.email);
        if (this.invalidEmail) {
            return;
        }
        this.subscribe('send-password-reset-email', authService.sendPasswordResetEmail(this.email), (task) => {
            this.submitTask = task;
        });
    }
};
ResetPassword = __decorate([
    Component({
        components: { ProgressButton }
    })
], ResetPassword);
export default ResetPassword;
